export default {
  timeChange: function (dataTime, hms) {
    if (!dataTime) {
      return ""
    }
    var unixTimestamp = new Date(dataTime + Number(timeZone) * 3600 * 1000)

    var year
    var month
    var day
    var hour
    var min
    var sec
    // 判断datatime的类型
    if ((typeof dataTime) === "number") {
      // 加入的时区因素，默认8，如果不是8，可在数据库配置，登陆时获取，存入localStorage
      var timeZone = localStorage.getItem("timeZone")
      if (!timeZone) {
        timeZone = 8
      }
      unixTimestamp = new Date(dataTime + Number(timeZone) * 3600 * 1000)

      year = unixTimestamp.getUTCFullYear()
      month = unixTimestamp.getUTCMonth() + 1
      day = unixTimestamp.getUTCDate()
      hour = unixTimestamp.getUTCHours()
      min = unixTimestamp.getUTCMinutes()
      sec = unixTimestamp.getUTCSeconds()
    } else {
      // 正则判断日期格式 IE浏览器
      var reg = RegExp(/-/)
      if (reg.test(dataTime)) {
        dataTime = dataTime.replace(/-/g, "/")
      }
      unixTimestamp = new Date(dataTime)
      year = unixTimestamp.getFullYear()
      month = unixTimestamp.getMonth() + 1
      day = unixTimestamp.getDate()
      hour = unixTimestamp.getHours()
      min = unixTimestamp.getMinutes()
      sec = unixTimestamp.getSeconds()
    }

    month = month < 10 ? `0${month}` : month
    day = day < 10 ? `0${day}` : day
    hour = hour < 10 ? `0${hour}` : hour
    min = min < 10 ? `0${min}` : min
    sec = sec < 10 ? `0${sec}` : sec
    var traslateTime
    if (hms === "ymd") { // 这个是2018-05-30格式
      traslateTime = `${year}-${month}-${day}`
    } else if (hms === "starts") {
      traslateTime = `${year}-${month}-${day} 00:00:00`
    } else if (hms === "ends") { // 2018-5-30 23:59:59
      traslateTime = `${year}-${month}-${day} 23:59:59`
    } else if (hms === "hms") { // yymmdd hhmmss
      traslateTime = `${year}-${month}-${day} ${hour}:${min}:${sec}`
    } else {
      traslateTime = `${year}-${month}-${day} ${hour}:${min}:${sec}`
    }
    return traslateTime
  },
  cs: function () {
    console.log("公共方法")
  },
  /**
 * 清除Cookies localStorage 标签等信息
 * @param
 * @returns
 */
  clearStorage () {
    // let cookiesAll = Cookies.get()
    // for (var k in cookiesAll) {
    //   if (Cookies.get(k)) {
    //     Cookies.remove(k)
    //   }
    // }
    // localStorage.removeItem("permittion")
  },
  /**
 * 获取前端存储
 * @param
 * @returns
 */
  localRead (key) {
    return localStorage.getItem(key) || ""
  }
}



// WEBPACK FOOTER //
// ./src/base/js/common.js